import { FC } from 'react';

import './Loader.scss';

interface iProps {
	transparent?: boolean,
	fullPage?: boolean,
	className?: string,
}


const Loader: FC<iProps> = ({transparent, fullPage, className}) => {


	if (fullPage) return (
		<div className="LoaderWrapper">
			<div className={"Loader " + (className ?? '')}>
				<div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
			</div>
		</div>
	)
	return (
		<div className={"Loader " + (className ?? '')}>
			<div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
		</div>
	)
}

export default Loader;